import React from 'react';
import PropTypes from 'prop-types';
import { Transition as ReactTransition } from 'react-transition-group';
import Velocity from 'velocity-animate';

import I18n from '@module/i18n';
import SplashpageHelper from '@app/helper/splashpage';

import Icon from '@component/icon';

import { WHITE, DARK_BLUE } from '@constant/colors';

export class Splashpage extends React.Component {
  handleEscape = (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    SplashpageHelper.trackFreeFunnel();

    this.props.onEscape();
  };

  // Fade-out and scale up when the component is going away
  onExit(component) {
    Velocity(
      component,
      {
        scale: '1.3',
        opacity: 0,
      },
      { duration: 300 }
    );
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEscape);

    SplashpageHelper.trackShow();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
  }

  handleClick = () => {
    SplashpageHelper.trackFreeFunnel();

    this.props.onClick();
  };

  handleFreeClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackFreeFunnel();

    this.props.onFreeClick();
  };

  handleFreeAccountClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackFreeAccountFunnel();

    this.props.onPlusClick(
      'WT202005_splashpage_anonym_to_fa',
      '/sign-up',
      'free'
    );
  };

  handlePlusClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackPlusFunnel();

    this.props.onPlusClick(
      'WT202005_splashpage_anonym_to_pro',
      '/sign-up',
      'plus'
    );
  };

  renderContent() {
    return (
      <div className="splashpage__background">
        <div className="content">
          <h1 className="content__heading">
            <p>{I18n.t('splash.heading.free_account')}</p>
          </h1>

          <div className="content__plans">
            <div className="plan plan--free">
              <div>
                <h2 className="plan__heading">
                  {I18n.t('splash.plan.free_account.heading')}
                </h2>

                <ul className="plan__features">
                  {SplashpageHelper.makeFreeAccountFeatureList()}
                </ul>
              </div>
              <button
                className="button button--free button--transparent"
                onClick={this.handleFreeAccountClick}
              >
                {I18n.t('splash.plan.free_account.cta')}
              </button>
            </div>

            <div className="plan plan--plus">
              <div>
                <h2 className="plan__heading">
                  {I18n.t('site.name')}
                  <Icon
                    type="TransferPlus"
                    color={WHITE}
                    backgroundColor={DARK_BLUE}
                  />
                </h2>

                <ul className="plan__features">
                  {SplashpageHelper.makeProFeatureList()}
                </ul>
              </div>
              <button
                className="button button--plus"
                onClick={this.handlePlusClick}
              >
                {I18n.t('splash.plan.pro.cta')}
              </button>
            </div>
          </div>
          <div className="free-button-wrapper">
            <button
              className="button button--enabled button--inline free-button"
              onClick={this.handleFreeClick}
            >
              {I18n.t('splash.footer.no_thanks')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <ReactTransition
        in={this.props.in}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={this.onExit}
      >
        <div className="splashpage" onClick={this.handleClick}>
          {this.renderContent()}
        </div>
      </ReactTransition>
    );
  }
}

Splashpage.propTypes = {
  in: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onFreeClick: PropTypes.func.isRequired,
  onPlusClick: PropTypes.func.isRequired,
  onEscape: PropTypes.func.isRequired,
};

export default Splashpage;
